import { render } from "./CurrencyField.vue?vue&type=template&id=006a1983"
import script from "./CurrencyField.vue?vue&type=script&lang=js"
export * from "./CurrencyField.vue?vue&type=script&lang=js"

import exportComponent from "/var/app/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CurrencyField.vue"]])

export default __exports__